import React from 'react';
import { Form, Input, Button, Card, Switch, InputNumber, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

const Settings: React.FC = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    console.log('Form values:', values);
    message.success('设置已保存');
  };

  return (
    <div>
      <h2>系统设置</h2>
      <Card>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            siteName: 'SHCLUB 潮鞋俱乐部',
            siteDescription: '专业的球鞋交易平台',
            enableRegistration: true,
            itemsPerPage: 10,
            contactEmail: 'support@shclub.com',
          }}
          onFinish={handleSubmit}
        >
          <Form.Item
            label="网站名称"
            name="siteName"
            rules={[{ required: true, message: '请输入网站名称' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="网站描述"
            name="siteDescription"
            rules={[{ required: true, message: '请输入网站描述' }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item
            label="开放注册"
            name="enableRegistration"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            label="每页显示数量"
            name="itemsPerPage"
            rules={[{ required: true, message: '请输入每页显示数量' }]}
          >
            <InputNumber min={1} max={100} />
          </Form.Item>

          <Form.Item
            label="联系邮箱"
            name="contactEmail"
            rules={[
              { required: true, message: '请输入联系邮箱' },
              { type: 'email', message: '请输入有效的邮箱地址' },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" icon={<SaveOutlined />} htmlType="submit">
              保存设置
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Settings; 